import {BaseCommandMessage, BaseResponseMessage} from "./base";
import {FavoriteDto} from "../favorites";

/**
 * Получить список избранных текущего пользователя.
 * См. `docs/specs/favorites.md` §6.1.
 */
export namespace GetFavoritesCommandNamespace {
    export const COMMAND = 'get_favorites';

    export class Request extends BaseCommandMessage {
        constructor() {
            super(COMMAND);
        }
    }

    export class Response extends BaseResponseMessage {
        constructor(
            override readonly id: number,
            readonly favorites: FavoriteDto[],
            readonly hiddenGuestCount: number = 0,
        ) {
            super(COMMAND, id, true);
        }
    }
}

/**
 * Добавить пользователя в избранное.
 *
 * `kind` в запросе НЕ передаётся — сервер сам определяет его по наличию аккаунта
 * с данным `login` в коллекции `users`. См. `docs/specs/favorites.md` §6.2.
 */
export namespace AddFavoriteCommandNamespace {
    export const COMMAND = 'add_favorite';

    export class Request extends BaseCommandMessage {
        constructor(readonly login: string) {
            super(COMMAND);
        }
    }

    export class Response extends BaseResponseMessage {
        constructor(
            override readonly id: number,
            readonly favorite?: FavoriteDto,
            readonly error?: number,
        ) {
            super(COMMAND, id, !!favorite);
        }
    }
}

/**
 * Удалить пользователя из избранного по `(owner, login)`.
 * См. `docs/specs/favorites.md` §6.3.
 */
export namespace RemoveFavoriteCommandNamespace {
    export const COMMAND = 'remove_favorite';

    export class Request extends BaseCommandMessage {
        constructor(readonly login: string) {
            super(COMMAND);
        }
    }

    export class Response extends BaseResponseMessage {
        constructor(
            override readonly id: number,
            readonly error?: number
        ) {
            super(COMMAND, id, !error);
        }
    }
}
